<template lang="pug">

    textarea(
        v-bind:value='value[field.id]'
        v-on:input='updateValue($event.target.value)'
    )

</template>

<script>
    export default {

        methods: {
            updateValue(value) {
                this.$emit('input', { ...this.value, [this.field.id]: value })
            }
        },

        props: {
            field: {
                type: Object,
                required: true
            },
            value: {
                type: Object,
                required: true
            }
        }

    }

</script>
